import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { ADD_TERMS_ACCEPTED_CAMPAIGN } from 'root/src/shared/descriptions/endpoints/endpointIds'
import updateTermsAccepted from 'root/src/client/logic/dropEvent/actions/updateTermsAccepted'

export default ({ campaignId, reservedPointsProjected, isReclaimReservation }) => async (dispatch) => {
	const payload = { campaignId, reservedPointsProjected, isReclaimReservation }
	const res = await dispatch(apiRequest(ADD_TERMS_ACCEPTED_CAMPAIGN, payload))
	const isSuccess = res.statusCode === 200
	if (!isSuccess) {
		throw res.error
	}
	dispatch(updateTermsAccepted(true))
}
